import { User } from '../types';

interface CatalystProjectUser {
  user_id?: string | number;
  zuid?: string | number;
  email_id?: string;
  first_name?: string;
  last_name?: string;
  role_name?: string;
  role_details?: {
    role_name?: string;
  };
}

interface CatalystAuthResponse {
  content?: CatalystProjectUser;
}

interface CatalystAuth {
  signIn: (elementId: string, config?: Record<string, unknown>) => void;
  isUserAuthenticated: () => Promise<CatalystAuthResponse>;
  signOut: (redirectUrl: string) => void;
}

interface CatalystGlobal {
  auth: CatalystAuth;
}

declare global {
  interface Window {
    catalyst?: CatalystGlobal;
  }
}

export const EMBEDDED_LOGIN_ELEMENT_ID = 'loginDivElementId';
export const LOGIN_REDIRECT_URL = '/app';
export const LOGOUT_REDIRECT_URL = '/app';

export function getCatalystAuth(): CatalystAuth {
  const auth = window.catalyst?.auth;

  if (!auth) {
    throw new Error('Catalyst Authentication no está disponible en el navegador');
  }

  return auth;
}

export function getEmbeddedSignInConfig() {
  return {
    service_url: LOGIN_REDIRECT_URL
  };
}

export function mapCatalystUserToAppUser(projectUser: CatalystProjectUser): User {
  const firstName = projectUser.first_name?.trim() || '';
  const lastName = projectUser.last_name?.trim() || '';
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  const roleName = projectUser.role_name || projectUser.role_details?.role_name || 'Admin';
  const normalizedRoleName = roleName.trim().toLowerCase().replace(/\s+/g, '_');
  const normalizedRole = normalizedRoleName === 'app_user'
    ? 'app_user'
    : normalizedRoleName === 'especialista'
      ? 'especialista'
      : 'admin';

  return {
    id: String(projectUser.user_id || projectUser.zuid || projectUser.email_id || 'admin'),
    name: fullName || projectUser.email_id || 'Administrador',
    email: projectUser.email_id || '',
    role: normalizedRole,
    roleName
  };
}
